<template>
  <div id="app">
    <template v-if="isLoggedIn">
      <el-container class="layout-root">
        <el-aside :width="isSidebarCollapsed ? '72px' : '240px'" class="sidebar">
          <div class="logo">
            <span class="logo-text">
              <span class="logo-text-line1">温岭迅驰软件开发工作室 ·</span>
              <span class="logo-text-line2">餐饮后台管理系统</span>
            </span>
          </div>
          <div class="sidebar-scroll">
            <el-menu
              :default-active="activeIndex"
              class="sidebar-menu"
              :collapse="isSidebarCollapsed"
              background-color="#1e1e1e"
              text-color="#ffffff"
              active-text-color="#ffffff"
              router
            >
              <!-- 区块 1：核心业务 -->
              <template v-if="!isSidebarCollapsed">
                <div class="sidebar-section-title">核心业务</div>
              </template>
              <el-menu-item v-if="!isStaffCashierSession" index="/">
                <i class="el-icon-s-home"></i>
                <span slot="title" v-if="!isSidebarCollapsed">工作台</span>
              </el-menu-item>
              <el-menu-item v-if="canMenuCashier()" index="/cashier">
                <i class="el-icon-shopping-cart-full"></i>
                <span slot="title" v-if="!isSidebarCollapsed">收银台</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('订单管理')" index="/orders">
                <i class="el-icon-document"></i>
                <span slot="title" v-if="!isSidebarCollapsed">随心订发货</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('订单管理')" index="/orders/situation">
                <i class="el-icon-document"></i>
                <span slot="title" v-if="!isSidebarCollapsed">收银台订单</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('订单管理')" index="/deferral-query">
                <i class="el-icon-date"></i>
                <span slot="title" v-if="!isSidebarCollapsed">延期查询</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('订单管理')" index="/meal-holiday-config">
                <i class="el-icon-setting"></i>
                <span slot="title" v-if="!isSidebarCollapsed">排餐配置</span>
              </el-menu-item>

              <template v-if="!isSidebarCollapsed">
                <div class="sidebar-section-divider"></div>
                <div class="sidebar-section-title">数据管理</div>
              </template>
              <el-menu-item v-if="hasMenuPerm('商品管理') && !isStaffCashierSession" index="/products">
                <i class="el-icon-goods"></i>
                <span slot="title" v-if="!isSidebarCollapsed">商品管理</span>
              </el-menu-item>
              <el-submenu v-if="hasMenuPerm('员工管理') && !isStaffCashierSession" index="/employee-mgmt">
                <template slot="title">
                  <i class="el-icon-s-custom"></i>
                  <span v-if="!isSidebarCollapsed">员工管理</span>
                </template>
                <el-menu-item index="/employees">
                  <span slot="title">员工管理</span>
                </el-menu-item>
                <el-menu-item
                  v-if="canReviewDeleteRequestsSession"
                  index="/delete-requests-review"
                >
                  <span slot="title">审核申请</span>
                </el-menu-item>
                <el-menu-item index="/store-attendance">
                  <span slot="title">门店考勤</span>
                </el-menu-item>
                <el-menu-item index="/attendance-calendar">
                  <span slot="title">出勤日历</span>
                </el-menu-item>
                <el-menu-item index="/operation-logs">
                  <span slot="title">操作日志</span>
                </el-menu-item>
              </el-submenu>
              <el-submenu v-if="hasMenuPerm('商品管理') && !isStaffCashierSession" index="/inventory">
                <template slot="title">
                  <i class="el-icon-refrigerator"></i>
                  <span v-if="!isSidebarCollapsed">库存管理</span>
                </template>
                <el-menu-item index="/inventory/dashboard">
                  <span slot="title">库存统计仪表盘</span>
                </el-menu-item>
                <el-menu-item index="/inventory/inbound-logs">
                  <span slot="title">入库日志统计</span>
                </el-menu-item>
                <el-menu-item index="/inventory/outbound-logs">
                  <span slot="title">出库日志统计</span>
                </el-menu-item>
                <el-menu-item index="/inventory/inout-report">
                  <span slot="title">出入库填报</span>
                </el-menu-item>
              </el-submenu>
              <el-menu-item v-if="hasMenuPerm('商品管理') && !isStaffCashierSession" index="/expiry-management">
                <i class="el-icon-time"></i>
                <span slot="title" v-if="!isSidebarCollapsed">效期管理</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('客户管理') && !isStaffCashierSession" index="/users">
                <i class="el-icon-user"></i>
                <span slot="title" v-if="!isSidebarCollapsed">客户与用户等级</span>
              </el-menu-item>
              <el-submenu v-if="hasMenuPerm('订单管理') && !isStaffCashierSession" index="/riders">
                <template slot="title">
                  <i class="el-icon-location-outline"></i>
                  <span v-if="!isSidebarCollapsed">骑手管理</span>
                </template>
                <el-menu-item index="/riders/info">
                  <span slot="title">骑手个人信息</span>
                </el-menu-item>
                <el-menu-item index="/riders/map">
                  <span slot="title">实时地图</span>
                </el-menu-item>
              </el-submenu>

              <template v-if="!isSidebarCollapsed">
                <div class="sidebar-section-divider"></div>
                <div class="sidebar-section-title">营销管理</div>
              </template>
              <el-menu-item v-if="hasMenuPerm('兑换券管理')" index="/vouchers">
                <i class="el-icon-ticket"></i>
                <span slot="title" v-if="!isSidebarCollapsed">兑换券管理</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('随心订管理') && !isStaffCashierSession" index="/subscription-calendar">
                <i class="el-icon-date"></i>
                <span slot="title" v-if="!isSidebarCollapsed">随心订日历</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('随心订管理') && !isStaffCashierSession" index="/mini-decoration">
                <i class="el-icon-picture-outline"></i>
                <span slot="title" v-if="!isSidebarCollapsed">小程序装修</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('随心订管理') && !isStaffCashierSession" index="/portal-site">
                <i class="el-icon-monitor"></i>
                <span slot="title" v-if="!isSidebarCollapsed">官网门户</span>
              </el-menu-item>

              <template v-if="!isSidebarCollapsed">
                <div class="sidebar-section-divider"></div>
                <div class="sidebar-section-title">会员管理</div>
              </template>
              <el-menu-item v-if="hasMenuPerm('客户管理') && !isStaffCashierSession" index="/member/level-rules">
                <i class="el-icon-s-data"></i>
                <span slot="title" v-if="!isSidebarCollapsed">等级规则</span>
              </el-menu-item>
              <el-menu-item v-if="hasMenuPerm('客户管理') && !isStaffCashierSession" index="/member/logs">
                <i class="el-icon-document"></i>
                <span slot="title" v-if="!isSidebarCollapsed">等级变动日志</span>
              </el-menu-item>
              <el-menu-item
                v-if="(hasMenuPerm('客户管理') && !isStaffCashierSession) || isStaffCashierSession"
                index="/member/points-mall"
              >
                <i class="el-icon-present"></i>
                <span slot="title" v-if="!isSidebarCollapsed">积分商城</span>
              </el-menu-item>
            </el-menu>
            <div class="sidebar-footer">
              <div
                v-if="!isSidebarCollapsed"
                class="sidebar-user sidebar-user--clickable"
                role="button"
                tabindex="0"
                @click="openAccountInfoDialog"
                @keyup.enter="openAccountInfoDialog"
              >
                <div class="sidebar-user-avatar">{{ userInitial }}</div>
                <div class="sidebar-user-meta">
                  <div class="sidebar-user-name">{{ userInfo.displayName || userInfo.username || '管理员' }}</div>
                  <div class="sidebar-user-role">{{ userInfo.roleLabel || '—' }}</div>
                </div>
              </div>
              <div
                v-else
                class="sidebar-user sidebar-user--collapsed sidebar-user--clickable"
                role="button"
                tabindex="0"
                title="账号信息"
                @click="openAccountInfoDialog"
                @keyup.enter="openAccountInfoDialog"
              >
                <div class="sidebar-user-avatar">{{ userInitial }}</div>
              </div>
              <div v-if="!isSidebarCollapsed" class="sidebar-footer-text">
                <div class="beian-inline"><beian-record-line light /></div>
                <div>温岭迅驰软件开发工作室-提供技术支持</div>
              </div>
            </div>
          </div>
        </el-aside>
        <el-container>
          <el-header class="topbar">
            <div class="topbar-inner">
              <div class="topbar-left">
                <el-button
                  type="text"
                  icon="el-icon-s-fold"
                  class="topbar-icon-btn"
                  @click="toggleSidebar"
                />
                <div class="topbar-brand-mark">
                  <span class="topbar-brand-dot" aria-hidden="true"></span>
                  <span class="topbar-brand-name">温岭EATing创意融合轻食</span>
                </div>
                <h1 class="page-title">{{ pageTitle }}</h1>
                <div class="top-tabs" v-if="activeIndex === '/orders'">
                  <el-button type="text" :class="{ active: subMenu === 'order' }" @click="changeOrderTab('order')">订单管理</el-button>
                  <el-button type="text" :class="{ active: subMenu === 'search' }" @click="changeOrderTab('search')">订单查询</el-button>
                  <el-button type="text" :class="{ active: subMenu === 'refund' }" @click="changeOrderTab('refund')">售后维权</el-button>
                  <el-button type="text" :class="{ active: subMenu === 'settings' }" @click="changeOrderTab('settings')">订单设置</el-button>
                </div>
              </div>
              <div class="topbar-right">
                <el-popover
                  placement="bottom"
                  width="260"
                  trigger="click"
                  v-model="notificationPopoverVisible"
                >
                  <div v-if="notifications.length">
                    <div
                      v-for="item in notifications"
                      :key="item._id"
                      class="notification-item"
                      style="margin-bottom: 8px; font-size: 12px;"
                      @click="handleNotificationClick(item)"
                    >
                      <div style="font-weight: 600;">{{ item.title }}</div>
                      <div style="color:#909399; margin-top:2px;">{{ item.content }}</div>
                    </div>
                    <el-button type="text" size="mini" @click="markAllNotificationsRead">
                      全部标为已读
                    </el-button>
                  </div>
                  <div v-else style="font-size: 12px; color:#909399;">暂无新通知</div>
                  <el-badge :value="unreadCount" class="item" slot="reference">
                    <el-button type="text" icon="el-icon-bell"></el-button>
                  </el-badge>
                </el-popover>
                <el-badge :value="5" class="item">
                  <el-button type="text" icon="el-icon-chat-line-round"></el-button>
                </el-badge>
                <el-dropdown @command="handleUserCommand">
                  <span class="el-dropdown-link">
                    {{ userInfo.displayName || userInfo.username }} <i class="el-icon-arrow-down"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="personal">个人中心</el-dropdown-item>
                    <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-header>
          <el-main style="padding: 0;">
            <div class="main-content">
              <router-view></router-view>
            </div>
          </el-main>
        </el-container>
      </el-container>

      <el-dialog
        title="账号信息"
        :visible.sync="accountDialogVisible"
        width="420px"
        append-to-body
        custom-class="account-info-dialog"
      >
        <div class="account-info-body">
          <div class="account-info-row">
            <span class="account-info-k">姓名</span>
            <span class="account-info-v">{{ userInfo.displayName || userInfo.username || '—' }}</span>
          </div>
          <div class="account-info-row">
            <span class="account-info-k">登录账号</span>
            <span class="account-info-v">{{ userInfo.username || '—' }}</span>
          </div>
          <div class="account-info-row">
            <span class="account-info-k">员工 ID</span>
            <span class="account-info-v">{{ userInfo.employeeId != null && userInfo.employeeId !== '' ? userInfo.employeeId : '—' }}</span>
          </div>
          <div class="account-info-row">
            <span class="account-info-k">角色</span>
            <span class="account-info-v">{{ userInfo.roleLabel || '—' }}</span>
          </div>
          <div class="account-info-row account-info-row--block">
            <span class="account-info-k">功能权限</span>
            <div v-if="userInfo.permissions && userInfo.permissions.length" class="account-info-perms">
              <el-tag
                v-for="p in userInfo.permissions"
                :key="p"
                size="small"
                type="info"
                effect="plain"
                class="account-info-tag"
              >{{ p }}</el-tag>
            </div>
            <span v-else class="account-info-v">—</span>
          </div>
          <div class="account-info-row">
            <span class="account-info-k">登录时间</span>
            <span class="account-info-v">{{ formatAccountLoginTime }}</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" plain @click="goToPersonalCenterFromAccount">个人中心</el-button>
          <el-button @click="accountDialogVisible = false">关闭</el-button>
        </span>
      </el-dialog>
    </template>
    <template v-else>
      <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { clearAuthSession, getAdminToken, getIsLoggedIn, getUserInfo } from './utils/auth'
import BeianRecordLine from './components/BeianRecordLine.vue'

export default {
  name: 'App',
  components: { BeianRecordLine },
  data() {
    return {
      subMenu: 'order',
      userInfo: {},
      loggedIn: getIsLoggedIn() && !!(getAdminToken() && String(getAdminToken()).trim()),
      isSidebarCollapsed: false,
      notifications: [],
      unreadCount: 0,
      notificationPopoverVisible: false,
      notificationTimer: null,
      accountDialogVisible: false
    }
  },
  computed: {
    activeIndex() {
      return this.$route.path;
    },
    pageTitle() {
      const titles = {
        '/': '工作台',
        '/employees': '员工管理',
        '/store-attendance': '门店考勤',
        '/attendance-calendar': '出勤日历',
        '/operation-logs': '操作日志',
        '/delete-requests-review': '审核申请',
        '/products': '商品管理',
        '/orders': '随心订发货',
        '/orders/situation': '收银台订单',
        '/cashier': '收银台',
        '/subscription-calendar': '随心订日历',
        '/mini-decoration': '小程序装修',
        '/portal-site': '官网门户',
        '/vouchers': '兑换券管理',
        '/inventory/dashboard': '库存统计仪表盘',
        '/inventory/inbound-logs': '入库日志统计',
        '/inventory/outbound-logs': '出库日志统计',
        '/inventory/inout-report': '出入库填报',
        '/member/level-rules': '等级规则',
        '/member/logs': '等级变动日志',
        '/member/points-mall': '积分商城',
        '/riders/info': '骑手个人信息',
        '/riders/map': '骑手实时地图',
        '/users': '客户与用户等级',
        '/personal': '个人中心',
        '/products/create': '创建商品'
      };
      return titles[this.activeIndex] || '管理系统';
    },
    isLoggedIn() {
      return this.loggedIn;
    },
    userInitial() {
      const n = (this.userInfo && (this.userInfo.displayName || this.userInfo.username)) || '管'
      return String(n).trim().slice(0, 1) || '管'
    },
    isAdminUser() {
      const u = this.userInfo
      return !!(
        u &&
        (u.role === 'admin' ||
          u.roleLabel === '管理员' ||
          u.roleLabel === '超级管理员')
      )
    },
    isStaffCashierSession() {
      const r = String((this.userInfo && this.userInfo.roleLabel) || '').trim()
      return r === '员工' || r === '收银员'
    },
    canReviewDeleteRequestsSession() {
      const r = String((this.userInfo && this.userInfo.roleLabel) || '').trim()
      return r === '管理员' || r === '超级管理员'
    },
    formatAccountLoginTime() {
      const t = this.userInfo && this.userInfo.loginTime
      if (!t) return '—'
      const d = new Date(t)
      if (Number.isNaN(d.getTime())) return String(t).slice(0, 19).replace('T', ' ')
      const p = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`
    }
  },
  mounted() {
    this.getUserInfo();
    // 未登录（如登录页）不请求通知接口，避免无意义 502 / 控制台报错
    this.syncNotificationPolling();
  },
  beforeDestroy() {
    this.stopNotificationPolling();
  },
  watch: {
    '$route': {
      handler() {
        this.loggedIn = getIsLoggedIn() && !!(getAdminToken() && String(getAdminToken()).trim())
        this.getUserInfo();
        this.syncNotificationPolling();
      },
      immediate: true
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
    stopNotificationPolling() {
      if (this.notificationTimer) {
        clearInterval(this.notificationTimer);
        this.notificationTimer = null;
      }
    },
    /** 仅登录后轮询未读通知；登出或停留在登录页时不请求 */
    syncNotificationPolling() {
      this.stopNotificationPolling();
      if (!getIsLoggedIn()) {
        this.notifications = [];
        this.unreadCount = 0;
        return;
      }
      this.fetchNotifications();
      this.notificationTimer = setInterval(() => {
        this.fetchNotifications(true);
      }, 15000);
    },
    async fetchNotifications(isAuto = false) {
      try {
        const resp = await this.$api.get('/admin/notifications/unread');
        if (resp && resp.code === 200) {
          let list = Array.isArray(resp.data) ? resp.data.slice() : [];
          const reviewNotices = await this.fetchPendingDeleteRequestNotices();
          if (reviewNotices.length) {
            const normalNotices = list.filter((x) => String((x && x.type) || '').trim() !== 'delete_request_review')
            list = [...reviewNotices, ...normalNotices]
          }
          if (isAuto && list.length > this.unreadCount && list[0]) {
            this.$notify({
              title: list[0].title || '随心订变更提醒',
              message: list[0].content || '',
              position: 'top-right',
              type: 'info'
            });
          }
          this.notifications = list;
          this.unreadCount = list.length;
        }
      } catch (e) {
        // 静默失败即可
      }
    },
    async fetchPendingDeleteRequestNotices() {
      if (!this.canReviewDeleteRequestsSession) return []
      try {
        const resp = await this.$api.get('/admin/delete-requests', { params: { status: 'pending' } })
        if (!resp || resp.code !== 200 || !Array.isArray(resp.data)) return []
        return resp.data.map((row) => {
          const id = Number(row && row.id)
          const target = row && row.target_label ? row.target_label : (row && row.target_id ? row.target_id : '-')
          const targetType = row && row.target_type ? row.target_type : '未知'
          return {
            _id: `delete-request-${id}`,
            type: 'delete_request_review',
            title: `审核申请待处理（申请ID：${id}）`,
            content: `目标类型：${targetType}，目标：${target}`,
            request_id: id
          }
        })
      } catch (_e) {
        return []
      }
    },
    async markAllNotificationsRead() {
      try {
        await this.$api.post('/admin/notifications/mark-all-read');
        await this.fetchNotifications();
        this.$message.success('通知已清空');
      } catch (e) {
        this.$message.error('操作失败');
      }
    },
    parseDeleteRequestIdFromNotification(item) {
      const type = String((item && item.type) || '').trim()
      if (type !== 'delete_request_review') return null
      const rid = Number(item && item.request_id)
      if (Number.isFinite(rid) && rid > 0) return rid
      const text = `${item && item.title ? item.title : ''} ${item && item.content ? item.content : ''}`
      const m = text.match(/申请ID[:：]\s*(\d+)/)
      if (!m) return null
      const n = Number(m[1])
      return Number.isFinite(n) ? n : null
    },
    async handleNotificationClick(item) {
      const type = String((item && item.type) || '').trim()
      if (type === 'backup_review_reminder') {
        this.notificationPopoverVisible = false
        try {
          await this.$router.push({ path: '/delete-requests-review' })
        } catch (_e) {
          /* ignore navigation duplicated */
        }
        return
      }
      const reqId = this.parseDeleteRequestIdFromNotification(item)
      if (!reqId) return
      this.notificationPopoverVisible = false
      try {
        await this.$router.push({ path: '/delete-requests-review', query: { deleteRequestId: String(reqId) } })
      } catch (_e) {
        /* ignore navigation duplicated */
      }
    },
    changeOrderTab(tab) {
      this.subMenu = tab;
      if (this.$route.path !== '/orders') {
        this.$router.push('/orders');
      }
    },
    handleUserCommand(cmd) {
      if (cmd === 'personal') return this.goToPersonalCenter()
      if (cmd === 'logout') return this.handleLogout()
    },
    getUserInfo() {
      this.userInfo = getUserInfo()
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        clearAuthSession()
        this.loggedIn = false
        this.userInfo = {};
        this.stopNotificationPolling();
        this.notifications = [];
        this.unreadCount = 0;

        // Hash 路由下最稳的方式：先用 router，再兜底直接改 hash
        this.$router.replace('/login').catch(() => {});
        this.$nextTick(() => {
          if (window.location.hash !== '#/login') {
            window.location.hash = '#/login'
          }
        })
        
        // 显示退出成功消息
        this.$message.success('退出登录成功！');
      }).catch(() => {
      });
    },
    goToPersonalCenter() {
      this.$router.push('/personal');
    },
    openAccountInfoDialog() {
      this.getUserInfo()
      this.accountDialogVisible = true
    },
    goToPersonalCenterFromAccount() {
      this.accountDialogVisible = false
      this.goToPersonalCenter()
    },
    hasMenuPerm(perm) {
      if (this.isAdminUser) return true
      const u = this.userInfo || {}
      return Array.isArray(u.permissions) && u.permissions.includes(perm)
    },
    canMenuCashier() {
      if (this.isAdminUser) return true
      const u = this.userInfo || {}
      if (u.roleLabel === '收银员') return true
      return this.hasMenuPerm('订单管理')
    }
  }
}
</script>

<style>
.layout-root {
  height: 100vh;
  background: #ffffff;
}

.sidebar {
  background: #1e1e1e;
  border-right: none;
  display: flex;
  flex-direction: column;
  color: rgba(255, 255, 255, 0.92);
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  background: #121212;
  flex-shrink: 0;
}

.logo-text {
  letter-spacing: 0.04em;
  color: #ffffff;
  white-space: normal;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 1.2;
  max-width: 100%;
}

.logo-text-line1 {
  font-size: clamp(13px, 1.6vw, 16px);
  font-weight: 700;
  white-space: nowrap;
}

.logo-text-line2 {
  font-size: clamp(10px, 1.2vw, 12px);
  font-weight: 500;
  opacity: 1;
  white-space: nowrap;
}

.sidebar-scroll {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
}

.sidebar-menu {
  border-right: none !important;
  background-color: transparent !important;
  padding: 10px 8px 8px;
  flex: 1;
  overflow-y: auto;
}

.sidebar-menu ::v-deep(.el-menu-item),
.sidebar-menu ::v-deep(.el-submenu__title) {
  height: auto;
  line-height: 1.45;
  padding: 11px 14px !important;
  margin: 2px 6px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  transition: background-color 0.2s ease, color 0.2s ease;
  color: #ffffff !important;
  background: transparent !important;
}

.sidebar-menu ::v-deep(.el-menu-item i),
.sidebar-menu ::v-deep(.el-submenu__title i) {
  font-size: 18px;
  margin-right: 10px;
  color: #ffffff;
}

.sidebar-menu ::v-deep(.el-menu-item span),
.sidebar-menu ::v-deep(.el-submenu__title span) {
  font-size: 14px;
  font-weight: 500;
  color: #ffffff;
}

.sidebar-menu ::v-deep(.el-menu-item:hover),
.sidebar-menu ::v-deep(.el-submenu__title:hover) {
  background-color: rgba(255, 255, 255, 0.06) !important;
}

.sidebar-menu ::v-deep(.el-menu-item.is-disabled),
.sidebar-menu ::v-deep(.el-submenu__title.is-disabled),
.sidebar-menu ::v-deep(.el-menu-item.is-disabled i),
.sidebar-menu ::v-deep(.el-menu-item.is-disabled span),
.sidebar-menu ::v-deep(.el-submenu__title.is-disabled i),
.sidebar-menu ::v-deep(.el-submenu__title.is-disabled span) {
  color: #ffffff !important;
  opacity: 1 !important;
}

.sidebar-menu ::v-deep(.el-menu-item.is-active) {
  background-color: #121212 !important;
  position: relative;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.sidebar-menu ::v-deep(.el-menu-item.is-active::before) {
  content: '';
  position: absolute;
  left: 4px;
  top: 10px;
  bottom: 10px;
  width: 3px;
  border-radius: 999px;
  background-color: #2ecc71;
}

.sidebar-menu ::v-deep(.el-menu-item.is-active i),
.sidebar-menu ::v-deep(.el-menu-item.is-active span) {
  color: #ffffff !important;
  font-weight: 600;
}

.sidebar-menu ::v-deep(.el-menu),
.sidebar-menu ::v-deep(.el-submenu .el-menu) {
  background-color: transparent !important;
}

.sidebar-menu ::v-deep(.el-submenu.is-opened > .el-submenu__title) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.sidebar-menu ::v-deep(.el-menu--inline) {
  background: #161616 !important;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  margin: 4px 8px 8px;
  padding: 4px 0;
}

.sidebar-menu ::v-deep(.el-submenu .el-menu-item) {
  margin: 2px 8px;
  min-width: auto;
}

.sidebar-menu ::v-deep(.el-submenu .el-menu-item:hover) {
  background-color: rgba(255, 255, 255, 0.08) !important;
}


.sidebar-menu ::v-deep(.el-submenu .el-menu-item.is-active) {
  background-color: #121212 !important;
}

/* 处理折叠菜单弹出层（挂载到 body）白底问题 */
.el-menu--popup {
  background: #161616 !important;
  border: 1px solid rgba(255, 255, 255, 0.08) !important;
}

.el-menu--popup .el-menu-item,
.el-menu--popup .el-submenu__title {
  color: #ffffff !important;
  background: transparent !important;
}

.el-menu--popup .el-menu-item i,
.el-menu--popup .el-submenu__title i,
.el-menu--popup .el-menu-item span,
.el-menu--popup .el-submenu__title span {
  color: #ffffff !important;
}

.el-menu--popup .el-menu-item:hover,
.el-menu--popup .el-submenu__title:hover {
  background-color: rgba(255, 255, 255, 0.08) !important;
}

.el-menu--popup .el-menu-item.is-active {
  background-color: #121212 !important;
}

.sidebar-section-title {
  font-size: 11px;
  font-weight: 600;
  color: #ffffff;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 8px 18px 4px;
  margin-top: 4px;
}

.sidebar-section-divider {
  height: 1px;
  margin: 8px 14px 6px;
  background-color: rgba(255, 255, 255, 0.08);
}

.sidebar-footer {
  flex-shrink: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding-top: 10px;
  background: #1a1a1a;
}

.sidebar-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px 12px;
}

.sidebar-user--collapsed {
  justify-content: center;
  padding-bottom: 14px;
}

.sidebar-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background: #121212;
  border: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  flex-shrink: 0;
}

.sidebar-user-meta {
  min-width: 0;
}

.sidebar-user-name {
  font-size: 14px;
  font-weight: 600;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-user-role {
  font-size: 12px;
  color: #ffffff;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-user--clickable {
  cursor: pointer;
  border-radius: 10px;
  margin: 0 8px 4px;
  padding: 8px 8px 12px;
  transition: background-color 0.2s ease;
  outline: none;
}

.sidebar-user--clickable:hover {
  background: rgba(255, 255, 255, 0.06);
}

.sidebar-user--clickable:focus-visible {
  box-shadow: 0 0 0 2px rgba(46, 204, 113, 0.45);
}

.sidebar-user--collapsed.sidebar-user--clickable {
  margin: 0 auto 8px;
  padding: 8px;
  width: fit-content;
}

.sidebar-footer-text {
  padding: 0 16px 14px;
  font-size: 11px;
  line-height: 1.45;
  color: #ffffff;
}

.beian-inline {
  white-space: nowrap;
}

.topbar {
  background: #121212 !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0 22px;
  height: 56px !important;
  line-height: 56px;
}

.topbar-inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.topbar-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}

.topbar-icon-btn {
  color: rgba(255, 255, 255, 0.88) !important;
  font-size: 20px;
  padding: 8px !important;
}

.topbar-icon-btn:hover {
  color: #ffffff !important;
}

.topbar-brand-mark {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 8px 0 4px;
  flex-shrink: 0;
}

.topbar-brand-dot {
  width: 10px;
  height: 10px;
  border-radius: 3px;
  background: #ffffff;
}

.topbar-brand-name {
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.page-title {
  margin: 0 0 0 12px;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #ffffff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.top-tabs {
  display: flex;
  gap: 8px;
  margin-left: 20px;
  align-items: center;
}

.top-tabs .el-button--text {
  color: rgba(255, 255, 255, 0.55) !important;
  font-size: 14px;
  font-weight: 500;
  padding: 6px 10px !important;
  position: relative;
}

.top-tabs .el-button--text:hover {
  color: #ffffff !important;
}

.top-tabs .el-button--text.active {
  color: #ffffff !important;
  font-weight: 600;
}

.top-tabs .el-button--text.active::after {
  content: '';
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 2px;
  height: 3px;
  border-radius: 3px 3px 0 0;
  background: #409eff;
}

.topbar-right {
  display: flex;
  align-items: center;
  gap: 8px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1;
}

.topbar-right .el-popover__reference-wrapper {
  display: inline-flex;
  align-items: center;
  line-height: 1;
  vertical-align: middle;
}

.topbar-right .el-button--text {
  color: rgba(255, 255, 255, 0.85) !important;
}

.topbar-right .el-button--text:hover {
  color: #ffffff !important;
}

/* 顶部栏角标：避免继承 header 大 line-height + 默认 translate 导致数字漂到栏外 */
.topbar-right .el-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  vertical-align: middle;
}

.topbar-right .el-badge .el-button--text {
  padding: 6px 8px !important;
  font-size: 18px;
  line-height: 1;
}

.topbar-right .el-badge .el-button--text [class^='el-icon-'] {
  vertical-align: middle;
}

.topbar-right .el-badge__content.is-fixed {
  top: 6px !important;
  right: 4px !important;
  transform: translate(50%, -50%) !important;
}

.el-dropdown-link {
  cursor: pointer;
  color: rgba(255, 255, 255, 0.92) !important;
  font-size: 14px;
  font-weight: 500;
}

.item {
  margin-top: 0;
}

.main-content {
  padding: 20px 24px 28px;
  background: #ffffff;
  min-height: calc(100vh - 56px);
}

/* ========== 库存管理：导入/导出纯文字、等内边距、内容居中 ========== */
.main-content .inv-mgmt-excel-actions {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
}

.main-content .inv-mgmt-excel-actions .inv-mgmt-upload {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

.main-content .inv-mgmt-excel-btn.el-button {
  margin: 0 !important;
  padding: 12px !important;
  min-width: 92px;
  box-sizing: border-box;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  height: auto !important;
  min-height: 36px;
  line-height: 1.4 !important;
}

.main-content .inv-mgmt-excel-btn.el-button span {
  margin: 0 !important;
}

.main-content .inv-mgmt-template-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 36px;
  padding: 8px 14px;
  margin: 0;
  color: var(--primary-color);
  font-size: 14px;
  text-decoration: none;
  border-radius: var(--radius-sm);
  cursor: pointer;
  white-space: nowrap;
}

.main-content .inv-mgmt-template-link:hover {
  text-decoration: underline;
}

.main-content .el-table td.inv-col-nowrap .cell {
  white-space: nowrap;
}

.account-info-body {
  font-size: 14px;
  color: #303133;
}

.account-info-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 12px;
  gap: 8px;
}

.account-info-row--block {
  flex-direction: column;
}

.account-info-k {
  flex: 0 0 88px;
  color: #909399;
  font-size: 13px;
}

.account-info-v {
  flex: 1;
  min-width: 0;
  word-break: break-all;
}

.account-info-perms {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.account-info-tag {
  margin: 0 !important;
}

.notification-item {
  cursor: pointer;
  border-radius: 8px;
  padding: 6px 8px;
}

.notification-item:hover {
  background: #f5f7fa;
}
</style>